export class Measurement {
  type: string;
  unit: string;
  value: string;
  rangeMin: string;
  rangeMax: string;
  constructor() {
  }
}
